export default __webpack_public_path__ + "static/carousel-2-281289dcdc57c4e15abdc295acb2816f.jpg";